<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" >
  html,body,#app {padding: 0;margin: 0; background-color: #f8f8f8;color: #333333;}
  *{box-sizing: border-box}
  .commonWrapper{ width: 1200px; margin: 0 auto;}
  .w1200{width: 1200px; margin: 0 auto;}
  ul,li{list-style: none;}
  a{text-decoration: none!important;color: inherit}
  table{
    width: 100%;
    border-collapse:collapse;}
  td,th{
    border:1px solid #f2f2f2;
  }
  .commnWrapper{
    padding: 20px 30px;
  }
  .marBottom20{margin-bottom: 20px;}
  .resultBack{  height: 54px;margin-top: 20px;padding: 0 20px;margin-bottom: 24px;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0px 5px 50px 0px
    rgba(229, 229, 229, 0.4);
    border-radius: 5px;
  .backWrapper{
    margin-right: 64px;
    cursor: pointer;
  img{
    width: 18px; height: 16px;vertical-align: middle;
    margin-right: 10px;
  }
  }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue